import script from "./PatientUploadFile.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientUploadFile.vue?vue&type=script&setup=true&lang=js"

import "./PatientUploadFile.vue?vue&type=style&index=0&id=056eb29f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-056eb29f"]])

export default __exports__